export default (dispatch, actions = {}) =>
  Object.entries(actions).reduce(
    (wrappedActions, [key, action]) => ({
      ...wrappedActions,
      [key]: (...args) => dispatch(action(...args)),
    }),
    {},
  );
